import {
  ConvertToSingleItemFetchProps,
  ConvertToSinglePickerProps
} from "./ExtendedPicker.types.ts";
import { withSingleItemFetch } from "./extendToSinglePicker.tsx";
import { extendToSingleTagPicker } from "./extendToSingleTagPicker.tsx";
import {
  GenericMultiTagPicker,
  GenericMultiTagPickerProps
} from "./MultiTagPicker.tsx";

const GenericPickerBase = withSingleItemFetch(
  extendToSingleTagPicker(GenericMultiTagPicker)
);

export type GenericPickerProps<TItem extends any> =
  ConvertToSingleItemFetchProps<
    ConvertToSinglePickerProps<GenericMultiTagPickerProps<TItem>, TItem>,
    TItem
  >;

/**
 * Generic Picker where the type of the item can be anything.
 * For this picker onResolveSuggestionItem and keyAccessor must be provided
 * @param props
 */
export const GenericPicker = <TItem extends {}>(
  props: GenericPickerProps<TItem>
) => {
  const TypedSinglePicker = GenericPickerBase as React.FunctionComponent<
    GenericPickerProps<TItem>
  >;
  return <TypedSinglePicker {...props} />;
};
